"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'userGroup.error.create': 'Failed to create user group',
};
